export const shopThisLook = 'lbl_outfit_shop_this_look';
export const outfitLabel = 'lbl_outfit_label';
export const outfitImage = 'lbl_outfit_image';
export const OutfitTileLabelsObj = {
  OutfitLabels: {
    Outfit_Sub: {
      [shopThisLook]: 'Shop This Look',
      [outfitLabel]: 'OUTFITS',
    },
  },
  global: {
    accessibility: {
      [outfitImage]: 'Outfit image',
    },
  },
};
